const fixGloboMobileMenu = () => {
    // Target all anchors in the mobile navigation drawer
    const navLinks = document.querySelectorAll('.menu-drawer__navigation .gm-item > a');

    navLinks.forEach((link) => {
        const parentLi = link.closest('li');
        const isLastItem = parentLi && parentLi.classList.contains('last-item');

        // 1. Logic for Parent Categories (Homeware, Kitchenware, etc.)
        if (!isLastItem) {
            // Ensure it has the class Globo needs
            if (!link.classList.contains('gm-target')) {
                link.classList.add('gm-target');
            }

            link.onclick = function (e) {
                // FIX: If the user clicked the arrow directly, let the event pass through.
                // This prevents the infinite loop and lets Globo's script work.
                if (e.target.classList.contains('gm-retractor')) {
                    return;
                }

                // Otherwise, if they clicked the text/background:
                e.preventDefault(); // Stop navigation to /collections/

                // Manually trigger the arrow to open the submenu
                const retractor = this.querySelector('.gm-retractor');
                if (retractor) {
                    retractor.click();
                }
            };
        }
        // 2. Logic for Final Items (Home Storage, Jugs, etc.)
        else {
            // Remove Globo classes so it behaves like a standard link
            link.classList.remove('gm-target');
            link.onclick = null;

            // Ensure the href is allowed to function
            link.style.pointerEvents = 'auto';
        }
    });
};

// Use MutationObserver to watch for the menu drawer opening
const observer = new MutationObserver(() => {
    fixGloboMobileMenu();
});

const mobileContainer = document.querySelector('.menu-drawer__navigation');
if (mobileContainer) {
    observer.observe(mobileContainer, {
        childList: true,
        subtree: true
    });
    fixGloboMobileMenu();
}